// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.addvideo .css-16r9pk3 {
  max-width: 1200px !important;
}

.addvideo .css-14yr603-MuiStepContent-root {
  margin-left: 0px !important;
  padding-left: 0px !important;
  padding-right: 0px !important;
  border-left: none !important;
}

.addvideo .css-ahj2mt-MuiTypography-root {
  margin: 0px !important;
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.5;
  letter-spacing: 0.00938em;
}

.image_error_msg {
  color: red;
}

.addvideo .css-1hv8oq8-MuiStepLabel-label.Mui-active {
  color: rgba(0, 0, 0, 0.87);
  font-weight: 600 !important;
}

.addvideo .small,
small {
  font-size: 12px !important;
}

.addvideo .css-1mz1l2x-MuiStepContent-root {
  padding-left: 0px !important;
  margin-left: 0px !important;
}

.addvideo .css-1bw0nnu-MuiStep-root {
  padding-left: 0px !important;
}

.video .css-z7uhs0-MuiStepConnector-line {
  display: block !important;
  border-color: #bdbdbd;
  border-top-style: none !important;
  border-top-width: 1px;
}

.addvideo .css-1qm1lh {
  margin-bottom: 16px;
  display: flex;
  justify-content: end;
}

.addvideo .css-ascpo7-MuiStepLabel-root {
  flex-direction: column;
}

.video {
  display: block !important;
}

.addvideo #label-file-upload {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-width: 2px;
  border-radius: 1rem;
  border-style: dashed;
  border-color: #cbd5e1;
  background-color: #f8fafc;
}

.addvideo .file-drag {
  height: 16rem;
  max-width: 100%;
  text-align: center;
  position: relative;
}

.addvideo #input-file-upload {
  justify-content: center;
  align-items: center;
  text-align-last: center;
}

.addvideo .css-sghohy-MuiButtonBase-root-MuiButton-root {
  background-color: #0d6efd !important;
}

.addvideo .css-sghohy-MuiButtonBase-root-MuiButton-root:hover {
  background-color: #0d6efd !important;
}

.addvideo .css-1e6y48t-MuiButtonBase-root-MuiButton-root {
  background-color: #646464 !important;
  color: #fff !important;
}

.addvideo .css-1e6y48t-MuiButtonBase-root-MuiButton-root:hover {
  background-color: #646464 !important;
  color: #fff !important;
}

.addvideo .css-1bw0nnu-MuiStep-root {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.searchWrapper {
  background: rgba(250, 250, 250, 1);
  border: 1px solid transparent;
  height: 45px;
  position: relative;
  font-size: 14px;
  width: 100%;
  -webkit-border-radius: 6px;
  height: 45px;
  border-radius: 4px;
  /* margin-bottom: 20px; */
  padding-left: 10px;
  font-weight: 400;
  line-height: 19px;
  color: #646464 !important;
  margin-top: 8px;
}

.videoupload {
  margin-bottom: 12px;
}


.formcreatable .css-13cymwt-control {
  background: rgba(250, 250, 250, 1);
  border: 1px solid transparent;
  height: 45px;
  position: relative;
  font-size: 14px;
  width: 100%;
  -webkit-border-radius: 6px;
  height: 45px;
  border-radius: 4px;
  /* margin-bottom: 20px; */
  padding-left: 10px;
  font-weight: 400;
  line-height: 19px;
  color: #646464 !important;
  margin-top: 8px;
}

.file-draganddrop {
  height: 100px;
  align-items: center;
  justify-content: center;
  border-width: 2px;
  border-radius: 1rem;
  border-style: dashed;
  text-align: center;
  border-color: #cbd5e1;
  background-color: transparent;
}

.file-e-paper {
  /* height: 100px; */
  align-items: center;
  justify-content: center;
  border-width: 2px;
  border-radius: 5px;
  border-style: dashed;
  text-align: center;
  border-color: #cbd5e1;
  color: #000000;
  background-color: transparent;
}

.intro_time_error {
  font-size: 12px;
  color: red;
  font-weight: 600;
}

.playerHeight {
  height: 200px !important;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Video/Video_Management/Editvideo.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;EAClC,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,0BAA0B;EAC1B,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;;AAGA;EACE,kCAAkC;EAClC,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,0BAA0B;EAC1B,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":[".addvideo .css-16r9pk3 {\n  max-width: 1200px !important;\n}\n\n.addvideo .css-14yr603-MuiStepContent-root {\n  margin-left: 0px !important;\n  padding-left: 0px !important;\n  padding-right: 0px !important;\n  border-left: none !important;\n}\n\n.addvideo .css-ahj2mt-MuiTypography-root {\n  margin: 0px !important;\n  font-weight: 400;\n  font-size: 1rem;\n  line-height: 1.5;\n  letter-spacing: 0.00938em;\n}\n\n.image_error_msg {\n  color: red;\n}\n\n.addvideo .css-1hv8oq8-MuiStepLabel-label.Mui-active {\n  color: rgba(0, 0, 0, 0.87);\n  font-weight: 600 !important;\n}\n\n.addvideo .small,\nsmall {\n  font-size: 12px !important;\n}\n\n.addvideo .css-1mz1l2x-MuiStepContent-root {\n  padding-left: 0px !important;\n  margin-left: 0px !important;\n}\n\n.addvideo .css-1bw0nnu-MuiStep-root {\n  padding-left: 0px !important;\n}\n\n.video .css-z7uhs0-MuiStepConnector-line {\n  display: block !important;\n  border-color: #bdbdbd;\n  border-top-style: none !important;\n  border-top-width: 1px;\n}\n\n.addvideo .css-1qm1lh {\n  margin-bottom: 16px;\n  display: flex;\n  justify-content: end;\n}\n\n.addvideo .css-ascpo7-MuiStepLabel-root {\n  flex-direction: column;\n}\n\n.video {\n  display: block !important;\n}\n\n.addvideo #label-file-upload {\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-width: 2px;\n  border-radius: 1rem;\n  border-style: dashed;\n  border-color: #cbd5e1;\n  background-color: #f8fafc;\n}\n\n.addvideo .file-drag {\n  height: 16rem;\n  max-width: 100%;\n  text-align: center;\n  position: relative;\n}\n\n.addvideo #input-file-upload {\n  justify-content: center;\n  align-items: center;\n  text-align-last: center;\n}\n\n.addvideo .css-sghohy-MuiButtonBase-root-MuiButton-root {\n  background-color: #0d6efd !important;\n}\n\n.addvideo .css-sghohy-MuiButtonBase-root-MuiButton-root:hover {\n  background-color: #0d6efd !important;\n}\n\n.addvideo .css-1e6y48t-MuiButtonBase-root-MuiButton-root {\n  background-color: #646464 !important;\n  color: #fff !important;\n}\n\n.addvideo .css-1e6y48t-MuiButtonBase-root-MuiButton-root:hover {\n  background-color: #646464 !important;\n  color: #fff !important;\n}\n\n.addvideo .css-1bw0nnu-MuiStep-root {\n  padding-left: 0px !important;\n  padding-right: 0px !important;\n}\n\n.searchWrapper {\n  background: rgba(250, 250, 250, 1);\n  border: 1px solid transparent;\n  height: 45px;\n  position: relative;\n  font-size: 14px;\n  width: 100%;\n  -webkit-border-radius: 6px;\n  height: 45px;\n  border-radius: 4px;\n  /* margin-bottom: 20px; */\n  padding-left: 10px;\n  font-weight: 400;\n  line-height: 19px;\n  color: #646464 !important;\n  margin-top: 8px;\n}\n\n.videoupload {\n  margin-bottom: 12px;\n}\n\n\n.formcreatable .css-13cymwt-control {\n  background: rgba(250, 250, 250, 1);\n  border: 1px solid transparent;\n  height: 45px;\n  position: relative;\n  font-size: 14px;\n  width: 100%;\n  -webkit-border-radius: 6px;\n  height: 45px;\n  border-radius: 4px;\n  /* margin-bottom: 20px; */\n  padding-left: 10px;\n  font-weight: 400;\n  line-height: 19px;\n  color: #646464 !important;\n  margin-top: 8px;\n}\n\n.file-draganddrop {\n  height: 100px;\n  align-items: center;\n  justify-content: center;\n  border-width: 2px;\n  border-radius: 1rem;\n  border-style: dashed;\n  text-align: center;\n  border-color: #cbd5e1;\n  background-color: transparent;\n}\n\n.file-e-paper {\n  /* height: 100px; */\n  align-items: center;\n  justify-content: center;\n  border-width: 2px;\n  border-radius: 5px;\n  border-style: dashed;\n  text-align: center;\n  border-color: #cbd5e1;\n  color: #000000;\n  background-color: transparent;\n}\n\n.intro_time_error {\n  font-size: 12px;\n  color: red;\n  font-weight: 600;\n}\n\n.playerHeight {\n  height: 200px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
